import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=c3c196e4&scoped=true"
import script from "./Relatorio.vue?vue&type=script&lang=js"
export * from "./Relatorio.vue?vue&type=script&lang=js"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=c3c196e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c196e4",
  null
  
)

export default component.exports